export default __webpack_public_path__ + "static/media/lock.216d679a.svg";